/** Column tracks measured from the design; the gaps between them flex with the card. */
export const DRIVER_GRID = ['266.286px', '126px', '126px', '126px', '63px'].join(' ')

/**
 * Card width in the design. At this width the columns land exactly where Figma places them;
 * wider viewports only widen the gaps, narrower ones scroll the list horizontally.
 */
export const DRIVER_MIN_WIDTH = 1277
